import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { getParticularPopUpMessage } from "../../../services/popUpManagement.service";

const TermAndCondition = ({
  isCheck,
  setIsCheck,
  open,
  close,
  type,
  handleSubmit,
  subscription,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleButton = () => {
    setIsCheck(true);
    setIsOpen(true);
    close(false);
    if (handleSubmit) {
      handleSubmit();
    }
  };

  const closeModel = () => {
    setIsOpen(true);
    close(false);
  };
  const [popUpDetails, setPopUpDetails] = useState({});
  useEffect(() => {
    const value = subscription ? 3 : 2;
    getParticularPopUpMessage(value)
      .then((res) => {
        setPopUpDetails(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "visible";
  }, [open]);

  return (
    <div>
      <Modal
        isOpen={open}
        toggle={() => {
          closeModel();
        }}
        size="lg"
        centered
        scrollable
        className="terms-modal"
      >
        <ModalHeader className="terms-modal-header">
          Terms & Conditions
        </ModalHeader>

        <ModalBody className="terms-modal-body">
          <div className="dynamic-popup-data-print-user">
            <div
              className="main-text"
              dangerouslySetInnerHTML={{ __html: popUpDetails?.message }}
            />
          </div>
        </ModalBody>
        {/* {subscription ? (
          <ModalBody>
            <ul style={{ listStyle: "none" }}>
              <h6 className="mb-1 fw-bolder">
                NOTE: This is an annual membership that is paid monthly. You
                will not be permitted to cancel or change your plan before the
                one-year term is complete.
              </h6>
              <li>
                <h6>1. Carat Club Membership </h6>
                <p>
                  The Carat Club Membership is a service provided by Uncut Gems
                  to its esteemed customers. As part of this membership, you
                  agree to pay a monthly fee for a period of one year (the
                  "Membership Term"), in exchange for a predetermined amount of
                  'carats' (referred to as "Carats"). Carats act as credits that
                  can be used to pay for orders. Upon the successful completion
                  of the first monthly payment, you will receive all Carats
                  relevant to your membership tier for the entire Membership
                  Term.
                </p>
                <li>
                  <h6>1.1 Membership Commitment and Cancellation</h6>
                  <p>
                    You agree and understand that the Carat Club Membership is a
                    one-year contract and cannot be canceled before the end of
                    the Membership Term. You acknowledge and understand that the
                    contract is binding and cancelling before the one-year term
                    ends is a violation of these Terms.
                  </p>
                  <p>
                    Should any monthly payment fail, Uncut Gems reserve the
                    right to pursue legal action, as we have already provided
                    you with the full year's worth of Carats based on your
                    initial payment.
                  </p>
                  <p>
                    You may submit a cancellation request, or a request to
                    upgrade or downgrade your membership plan at any time.
                    However, please note that any such change will only go into
                    effect at the start of your next Membership Term, not during
                    the current term.
                  </p>
                </li>
                <li>
                  <h6>1.2 Additional Carats</h6>
                  <p>
                    You have the option to purchase additional Carats at any
                    time. The cost of these Carats will be the same as the
                    per-Carat cost at your current membership tier.
                  </p>
                </li>
                <li>
                  <h6>1.3 Carat Rollover and Forfeit</h6>
                  <p>
                    Unused Carats will roll over from year to year as long as
                    your Carat Club Membership remains active. If you cancel
                    your Carat Club Membership, you will forfeit any and all
                    remaining Carats, and they will not be refundable or
                    transferable.
                  </p>
                </li>
              </li>
            </ul>
          </ModalBody>
        ) : (
          <ModalBody className="terms-modal-body">
            <ul style={{ listStyle: "none" }}>
              <li>
                <h6>1. Acceptance of Terms </h6>
                <p>
                  The customer acknowledges that it is the owner or lawful
                  licensee of the materials supplied.
                  <br /> Please read these Terms carefully. By using our
                  Services, you agree to be bound by these Terms, including the
                  policies referenced in these Terms (such as our Privacy
                  Policy). If you do not agree to these Terms, do not use our
                  Services.
                </p>
              </li>
              <li>
                <h6>2. Ownership and License</h6>
                <p>
                  You retain ownership of all Content you submit to Uncut Gems.
                  You affirm, represent, and warrant that you own or have the
                  necessary licenses, rights, consents, and permissions to use
                  and authorize Uncut Gems to use all patent, trademark, trade
                  secret, copyright, or other proprietary rights in and to any
                  and all Content to enable inclusion and use of the Content in
                  the manner contemplated by Uncut Gems and these Terms.
                </p>
              </li>
              <li>
                <h6>3. Client Confidentiality</h6>
                <p>
                  We value your privacy. Please review our Privacy Policy to
                  learn more about how we collect and use information about you
                  via the Service. By using the Services, you consent to the
                  transfer of your information to the United States and/or other
                  countries for storage, processing, and use by Uncut Gems, in
                  accordance with our Privacy Policy.
                </p>
              </li>
              <li>
                <h6>4. Feedback and Communication</h6>
                <p>
                  For feedback, comments, requests for technical support, and
                  other communications relating to the Services, you should use
                  the comment section on the order itself in our client portal
                  or email us at hello@uncutgems.com.
                  <br />
                  If you wish to request any adjustments to the work delivered,
                  you must do so within 7 working days from the date of receipt
                  of the order. After this period, Uncut Gems will not be able
                  to accommodate adjustments or issue refunds. Please make sure
                  you review your order promptly upon receiving it and submit
                  any feedback or amendment requests within the given timeframe.
                </p>
              </li>
              <li>
                <h6 className="mb-1">5. Revision Requests</h6>
                <li>
                  <h6 style={{ marginBottom: "16px" }}>
                    5.1 Definition of Revision :
                    <span className="h6-span">
                      &nbsp; A "revision" refers to any change, modification, or
                      adjustment to the wedding video that has already been
                      edited and presented to the client.
                    </span>
                  </h6>
                </li>
                <li>
                  <h6 className="mb-1">
                    5.2 Number of Free Revisions :
                    <span className="h6-span">
                      &nbsp;The client is entitled to two (2) rounds of
                      revisions at no additional cost.
                    </span>
                  </h6>
                </li>
                <li>
                  <h6>
                    5.3 Scope of Revisions :
                    <span className="h6-span">
                      &nbsp; Free revisions cover minor edits such as color
                      correction, changing of scenes or sequencing, audio
                      adjustments, and addition or removal of specific clips.
                    </span>
                  </h6>
                  <p>
                    Significant restructuring of the video, addition of content
                    not provided during the initial submission, or requesting
                    changes that deviate drastically from the initial brief may
                    be considered outside the scope of the free revisions and
                    may incur an additional fee. The determination of what
                    constitutes a major change will be at the discretion of the
                    company.
                  </p>
                </li>
                <li>
                  <h6>
                    5.4 Submission of Edit Requests :
                    <span className="h6-span">
                      &nbsp;All revision requests must be submitted in writing,
                      either through email or our designated platform.
                    </span>
                  </h6>
                  <p>
                    Requests should be clear, concise, and specific to ensure
                    prompt and accurate edits.
                    <br />
                    If possible, please provide time-stamped references to
                    indicate where changes are desired in the video.
                    <br />
                    Revision Turnaround Time: We aim to complete revisions
                    within 5-7 business days from the receipt of the revision
                    request. However, turnaround times may vary depending on the
                    complexity of the edits and our current workload. We will
                    communicate any potential delays in advance.
                  </p>
                </li>
                <li>
                  <h6>
                    5.5 Additional Revisions :
                    <span className="h6-span">
                      &nbsp; Should the client require more than three rounds of
                      revisions, an additional fee will be charged for each
                      subsequent round. The amount of this fee will be
                      communicated and agreed upon prior to the commencement of
                      additional edits.
                    </span>
                  </h6>
                  <p>
                    The client will be notified after the third round of
                    revisions that any further requests will be chargeable.
                  </p>
                </li>
                <li>
                  <h6>
                    5.6 Final Approval :
                    <span className="h6-span">
                      &nbsp; Once the third round of revisions (or any
                      subsequent paid revisions) is complete and the video has
                      been delivered to the client, the client has 7 days to
                      provide final approval or further revision requests.
                    </span>
                  </h6>
                  <p>
                    If no feedback is received within the 7-day period, the
                    video will be considered approved and finalized.
                  </p>
                </li>
              </li>
              <li>
                <h6>6. Turnaround times</h6>
                <p>
                  Please be aware that all provided turnaround times are
                  estimations. Due to the personalized nature of the services
                  Uncut Gems offers, there may be instances, particularly in
                  extreme circumstances, where these turnaround times may need
                  to be extended.
                  <br />
                  Furthermore, between August and November, the turnaround times
                  may vary more than usual. We recommend adding extra days to
                  your expected turnaround time during these months to account
                  for potential fluctuations. Your understanding and patience
                  are greatly appreciated.
                  <br />
                  It’s important to note that the countdown for the estimated
                  turnaround time commences only after Uncut Gems has received
                  all the necessary assets required to complete the job. This
                  includes but is not limited to, 100% of the footage, songs,
                  text, or any other materials needed. The turnaround time is
                  calculated from the moment we have received all of these
                  assets in full, and not from the point of order placement or
                  partial asset submission. Please ensure that all necessary
                  materials are submitted promptly to avoid any delay in the
                  completion of your project.
                </p>
              </li>
              <li>
                <h6>7. Order Cancellation</h6>
                <p>
                  Once an order is placed, you have a 24-hour window to cancel
                  it, although cancellation within this time period is not
                  guaranteed and is subject to our discretion. After 24 hours
                  have passed, no cancellations will be accepted. Therefore, we
                  encourage you to carefully review your order before
                  submission.
                </p>
              </li>
              <li>
                <h6>8. Complaints and Dispute Resolution</h6>
                <p>
                  We aim to deal with all complaints as effectively as possible.
                  In the first instance, your initial communication will be with
                  our Customer Service team who will listen to your complaint
                  and where possible, aim to resolve the complaint. If you are
                  not satisfied with the solution, you can escalate your
                  complaint by contacting us at hello@uncutgems.com.
                </p>
              </li>
              <li>
                <h6>9. Limitation of Liability</h6>
                <p>
                  In no event will Uncut Gems, its affiliates or their
                  licensors, service providers, employees, agents, officers or
                  directors be liable for damages of any kind, under any legal
                  theory, arising out of or in connection with your use, or
                  inability to use, our services, any content on our services or
                  such other websites or any services or items obtained through
                  our services or such other websites.
                </p>
              </li>
              <li>
                <h6>10. Indemnification</h6>
                <p>
                  You agree to defend, indemnify, and hold harmless Uncut Gems,
                  its parent corporation, officers, directors, employees, and
                  agents, from and against any and all claims, damages,
                  obligations, losses, liabilities, costs or debt, and expenses
                  (including but not limited to attorney’s fees) arising from
                  your use of and access to the Service, or any Content that you
                  post to the Service, violation of these Terms, or violation of
                  any third-party right, including without limitation any
                  copyright, property, or privacy right.
                </p>
              </li>
              <li>
                <h6>11. Changes to Terms and Conditions</h6>
                <p>
                  Uncut Gems reserves the right to amend these Terms at any time
                  and without notice, and it is your responsibility to review
                  these Terms for any changes. Your use of Uncut Gems’ Services
                  following any amendment of these Terms will signify your
                  assent to and acceptance of its revised terms. For any
                  questions or concerns, please email us at hello@uncutgems.com.
                </p>
              </li>
              <li>
                <h6>12. Carat Club Membership</h6>
                <p>
                  The Carat Club Membership is a service provided by Uncut Gems
                  to its esteemed customers. As part of this membership, you
                  agree to pay a monthly fee for a period of one year (the
                  “Membership Term”), in exchange for a predetermined amount of
                  ‘carats’ (referred to as “Carats”). Carats act as credits that
                  can be used to pay for orders. Upon the successful completion
                  of the first monthly payment, you will receive all Carats
                  relevant to your membership tier for the entire Membership
                  Term.
                </p>
                <li>
                  <h6>12.1 Membership Commitment and Cancellation</h6>
                  <p>
                    You agree and understand that the Carat Club Membership is a
                    one-year contract and cannot be canceled before the end of
                    the Membership Term. You acknowledge and understand that the
                    contract is binding and cancelling before the one-year term
                    ends is a violation of these Terms.
                    <br />
                    Should any monthly payment fail, Uncut Gems reserves the
                    right to pursue legal action, as we have already provided
                    you with the full year’s worth of Carats based on your
                    initial payment.
                    <br />
                    You may submit a cancellation request, or a request to
                    upgrade or downgrade your membership plan at any time.
                    However, please note that any such change will only go into
                    effect at the start of your next Membership Term, not during
                    the current term.
                  </p>
                </li>
                <li>
                  <h6>12.2 Additional Carats</h6>
                  <p>
                    You have the option to purchase additional Carats at any
                    time. The cost of these Carats will be the same as the
                    per-Carat cost at your current membership tier.
                  </p>
                </li>
                <li>
                  <h6>12.3 Carat Rollover and Forfeit</h6>
                  <p>
                    Unused Carats will roll over from year to year as long as
                    your Carat Club Membership remains active. If you cancel
                    your Carat Club Membership, you will forfeit any and all
                    remaining Carats, and they will not be refundable or
                    transferable.
                    <br />
                    Please note that these Terms are legally binding. By
                    subscribing to the Carat Club Membership, you are agreeing
                    to these Terms. If you have any questions or concerns,
                    please contact us at hello@uncutgems.com.
                  </p>
                </li>
              </li>
            </ul>
          </ModalBody>
        )} */}

        <ModalFooter className="justify-content-between">
          <div className="text-start">
            <Input
              id="basicInput"
              className="m-1 me-50 cursor-pointer"
              type="checkbox"
              value={isCheck}
              onChange={() => setIsOpen(!isOpen)}
            />
            <Label
              className="form-label m-1 ms-25 cursor-pointer"
              for="basicInput"
            >
              Terms & Conditions Apply
            </Label>
          </div>
          {/* </Col> */}
          {/* <Col xl={12} xxl={12} md={12} sm={12} className="text-center"> */}
          <Button
            color="primary"
            onClick={() => handleButton()}
            disabled={isOpen}
            type={type}
          >
            Accept
          </Button>
          {/* </Col>
          </Row> */}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default TermAndCondition;
